<template>
    <div>
      <h1>Enroll in the Course</h1>
      <p>Enroll now to start your journey in affiliate marketing.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AffiliateEnroll',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>